// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i54j","content":"styles_content__18YW0","footText":"styles_footText__gPNPy"};